/**
 * Official brand domains, used to fetch manufacturer logos from Logo.dev.
 * Keyed by the `makes.slug` value stored in the database.
 */
export const BRAND_DOMAINS: Record<string, string> = {
  acura: "acura.com",
  "alfa-romeo": "alfaromeo.com",
  "aston-martin": "astonmartin.com",
  audi: "audi.com",
  bentley: "bentleymotors.com",
  bmw: "bmw.com",
  bugatti: "bugatti.com",
  "bugatti-rimac": "bugatti.com",
  buick: "buick.com",
  byd: "byd.com",
  cadillac: "cadillac.com",
  chevrolet: "chevrolet.com",
  chrysler: "chrysler.com",
  dodge: "dodge.com",
  ferrari: "ferrari.com",
  fiat: "fiatusa.com",
  fisker: "fiskerinc.com",
  ford: "ford.com",
  genesis: "genesis.com",
  gmc: "gmc.com",
  honda: "honda.com",
  hyundai: "hyundai.com",
  "ineos-automotive": "ineosgrenadier.com",
  infiniti: "infinitiusa.com",
  jaguar: "jaguar.com",
  jeep: "jeep.com",
  kandi: "kandiamerica.com",
  karma: "karmaautomotive.com",
  kia: "kia.com",
  koenigsegg: "koenigsegg.com",
  lamborghini: "lamborghini.com",
  "land-rover": "landrover.com",
  lexus: "lexus.com",
  lincoln: "lincoln.com",
  lordstown: "lordstownmotors.com",
  lotus: "lotuscars.com",
  lucid: "lucidmotors.com",
  maserati: "maserati.com",
  mazda: "mazda.com",
  "mclaren-automotive": "mclaren.com",
  "mercedes-benz": "mercedes-benz.com",
  mini: "mini.com",
  mitsubishi: "mitsubishicars.com",
  "mobility-ventures-llc": "mobilityventuresllc.com",
  nissan: "nissanusa.com",
  pagani: "pagani.com",
  polestar: "polestar.com",
  porsche: "porsche.com",
  ram: "ramtrucks.com",
  rivian: "rivian.com",
  "rolls-royce": "rolls-roycemotorcars.com",
  "roush-performance": "roushperformance.com",
  "ruf-automobile": "ruf-automobile.de",
  scion: "toyota.com",
  smart: "smart.com",
  sti: "subaru.com",
  subaru: "subaru.com",
  tesla: "tesla.com",
  toyota: "toyota.com",
  vinfast: "vinfastauto.us",
  volkswagen: "vw.com",
  volvo: "volvocars.com",
};

export function brandDomain(makeSlug: string): string | undefined {
  return BRAND_DOMAINS[makeSlug];
}